<template>
  <div>
    <v-container fluid class="pb-0">
      <v-row no-gutters :class="{'pl-8': !esMovil}">
        <v-col :cols="esMovil ? 12 : 6" class="primary--text"
               :class="{'izquierda-principal': !esMovil, 'pr-16':!esMovil, 'mt-4': esMovil}">
          <p class="headline font-weight-bold">{{ $t('titulo') }}</p>
          <p class="title">{{ $t('descripcion') }}</p>
        </v-col>
      </v-row>

      <v-row v-for="(seccion, index) in secciones" :key="index">
        <v-col :cols="esMovil ? 12 : 6" class="pa-4 primary--text"
               :class="{ 'salmon': esMovil || index % 2, 'grey lighten-3': !esMovil && !(index % 2), 'izquierda': !esMovil}">
          <p class="headline font-weight-bold" v-html="$options.filters.capitalize(seccion.titulo)"/>
          <p class="body-1" v-for="(texto, idxSec) in seccion.descripcion" :key="`sec-${index}-${idxSec}-`"
             v-html="texto"/>
        </v-col>
        <v-col :cols="esMovil ? 12 : 6" class="pa-4 primary--text"
               :class="{ 'grey lighten-3': esMovil || index % 2, 'salmon': !esMovil && !(index % 2), 'derecha': !esMovil}">
          <div class="d-flex flex-row flex-wrap">
            <div v-for="(enlace,index) in seccion.enlaces" :key="index" class="enlace mx-4"
                 :class="{'hand': hayUsuario}" v-ripple="hayUsuario" @click="abrirPdf(enlace.url)">
              <v-tooltip bottom :disabled="hayUsuario">
                <template v-slot:activator="{on}">
                  <div v-on="on">
                    <v-img :src="require('../../assets/iconos/descarga_white.png')" contain
                           width="70" class="ma-auto"></v-img>
                    <p class="body-1 text-center mt-4">{{ enlace.descripcion | capitalize }}</p>
                    <v-progress-linear v-show="cargando === enlace.url" indeterminate
                                       color="primary"/>
                  </div>
                </template>
                <span>{{ $t("alerta_login") }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";
import DescargasHelper from "@/comunes/helpers/DescargasHelper";

export default {
  name: 'OpinionPagina',
  components: {},
  data: () => ({
    cargando: null
  }),
  computed: {
    ...mapState(["usuario"]),
    hayUsuario() {
      return this.usuario != null;
    },
    secciones() {
      return [
        {
          titulo: this.$t("metodologia_titulo"),
          descripcion: [this.$t("metodologia_texto_1"), this.$t("metodologia_texto_2")],
          enlaces: [
            {url: "metodologia", descripcion: this.$t("metodologia_titulo")},
            {url: "fuentesConsultadas", descripcion: this.$t("fuentes_consultadas")}
          ]
        },
        {
          titulo: this.$tc("solucion_constructiva", 2),
          descripcion: [this.$t("sc_texto")],
          enlaces: [
            {url: "horizontal", descripcion: this.$tc("particion_horizontal", 2)},
            {url: "vertical", descripcion: this.$tc("particion_vertical", 2)},
            {url: "fachada", descripcion: this.$tc("particion_fachada", 2)},
            {url: "urbano", descripcion: this.$tc("particion_urbano", 2)}
          ]
        },
        {
          titulo: this.$t("ventas_titulo"),
          descripcion: [this.$t("ventas_texto")],
          enlaces: [{url: "ventas", descripcion: this.$t("arg_ventas")}]
        }
      ]
    },
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    abrirPdf(nombre) {
      if (!this.hayUsuario) return;

      this.cargando = nombre;
      HttpHelper.get(`descargas/pdf/${nombre}`)
          .then((respuesta) => {
            DescargasHelper.descargarBase64(respuesta.name, respuesta.data, respuesta.extension);
          })
          .catch((error) => {
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: this.$t(error.status === 403 ? "error_403" : "error_desconocido"),
              color: "error"
            });
          })
          .finally(() => {
            this.cargando = null;
          });
    }
  }
};
</script>

<style lang="scss" scoped>
.izquierda-principal {
  padding-left: calc(50% - 592px) !important;
}

.izquierda {
  padding: 50px 50px 50px calc(50% - 592px) !important
}

.derecha {
  padding: 50px calc(50% - 592px) 50px 50px !important
}

.enlace {
  width: 100px;
}

.hand {
  cursor: pointer;
}

.salmon {
  background: #f7d9cd !important;
}

</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "titulo": "Documentos de descarga",
    "descripcion": "Toda la información necesaria para entender y aprovechar al máximo Solconcer.",
    "metodologia_titulo": "Metodología",
    "fuentes_consultadas": "Fuentes consultadas",
    "metodologia_texto_1": "Informe de descarga donde se detalla de manera precisa todos los aspectos relacionados con la metodología de cálculo empleada en Solconcer",
    "metodologia_texto_2": "Además, para ofrecer mayor transparencia, se ofrece otro documento donde se enumeran las fuentes consultadas para la obtención de los datos utilizados para la evaluación de las soluciones constructivas.",
    "sc_texto": "Informes de descarga donde se caracterizan las soluciones constructivas evaluadas y se definen las hipótesis de cálculo consideradas en cada una de ellas.",
    "ventas_titulo": "Argumentario de ventas",
    "ventas_texto": "Documento que pretende, de manera resumida, directa y simplificada, transmitir información relativa a las características de los materiales de recubrimiento que puede ser clave en un proceso de venta. Todo ello basado en la metodología de Solconcer.",
    "arg_ventas": "Argumentario de ventas",
    "alerta_login": "Regístrate o inicia sesión para poder descargar los documentos",
    "error_403": "No se pueden descargar los documentos si no ha aceptado la política de privacidad. Debe acceder a su perfil para aceptarla"
  }
}
</i18n>
<!-- @formatter:on -->